import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Icon from 'srcReact/components/icons/Icon'
import { redirectToPage } from 'srcReact/helpers/history'
import Button from 'srcReact/components/common2/Button'
import { sidebarActions } from '../../action'
import styles from './styles.module.scss'

function CreatePopup({ handleClose, isNative, hasGroupOrMixrHomePage, mixrHomeActive }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const handleRedirect = (page) => {
    redirectToPage(page, isNative)
  }

  /* `hasGroupOrMixrHomePage` is a boolean variable that determines whether the user is on a
    group or mixr home page. */
  const handleWritePost = () => {
    if (!hasGroupOrMixrHomePage) {
      if (isNative) {
        handleRedirect('/0/feed?popup=true')
        return
      }
      handleRedirect('/0/feed')
    }
    dispatch(sidebarActions.setCreatePostPopup(true))
    handleClose()
  }
  const handlePlanMixr = () => {
    const pathArray = window.location.pathname.split('/')
    const groupId = pathArray[pathArray.indexOf('group') + 1]
    if (groupId > 0) {
      handleRedirect(`/0/${groupId}/create-mixr`)
    } else {
      handleRedirect('/0/create-mixr')
    }
    handleClose()
  }
  return (
    <div className={styles.createPopupContainer}>
      <Button
        text={t('global.writePost')}
        customStyle={styles.btnWritePost}
        iconPosition='start'
        style='secondary'
        icon={<Icon styleModifier={styles.icon} name='write' />}
        handleClick={handleWritePost}
      />
      {!mixrHomeActive && (
        <Button
          text={t('global.planMixr')}
          customStyle={styles.btnPlanMixr}
          iconPosition='start'
          style='primary'
          icon={<Icon styleModifier={styles.icon} name='calendar24' />}
          handleClick={handlePlanMixr}
        />
      )}
      {!hasGroupOrMixrHomePage && (
        <Button
          text={t('nav.create_group')}
          customStyle={styles.btnCreateGroup}
          iconPosition='start'
          style='primary'
          icon={<Icon styleModifier={styles.icon} name='groups24' />}
          handleClick={() => handleRedirect('/0/create-group')}
        />
      )}
      <div role='button' className={styles.btnClose} onClick={handleClose}>
        <Icon name='add' />
      </div>
    </div>
  )
}

export default CreatePopup
